import { render, staticRenderFns } from "./PromocodePreference.vue?vue&type=template&id=793e898c&"
import script from "./PromocodePreference.vue?vue&type=script&lang=js&"
export * from "./PromocodePreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports